import { FC } from "react";

export const DefaultViewBadge: FC = () => (
  <span className="npm-qes-sv-badge npm-qes-sv-badge--default" data-testid="npm-sv-default-badge">Default</span>
);
